// Actions
export const GET_ATTACHMENTS = 'GET_ATTACHMENTS';
export const ADD_ATTACHMENTS = 'ADD_ATTACHMENTS';
export const REMOVE_ATTACHMENTS = 'REMOVE_ATTACHMENTS';
export const ADD_STAGING_ATTACHMENTS = 'ADD_STAGING_ATTACHMENTS';
export const REMOVE_STAGING_ATTACHMENTS = 'REMOVE_STAGING_ATTACHMENTS';
export const CLEAR_STAGING_ATTACHMENTS = 'CLEAR_STAGING_ATTACHMENTS';
export const UPDATE_ATTACHMENTS_VALIDATION = 'UPDATE_ATTACHMENTS_VALIDATION';
export const CLEAR_ALL_ATTACHMENTS = 'CLEAR_ALL_ATTACHMENTS';

// Initial State
export const attachmentsInitial = {
  saved: [],
  staged: [],
  uploads: {
    addressAttachment: { required: false, files: [] },
    taxAttachment: { required: false, files: [] },
    ineAttachment: { required: false, files: [] },
    constitutiveActAttachment: { required: false, files: [] },
    financialStatementsAttachment: { required: false, files: [] },
    accountAttachment: { required: false, files: [] },
    taxExemptAttachment: { required: false, files: [] },
    financialCardAttachment: { required: false, files: [] },
    additionalAttachment: { required: false, files: [] }
  }
};

// Reducer
export function attachments(state, action) {
  if (!state) {
    state = attachmentsInitial;
  }

  switch (action.type) {
    case GET_ATTACHMENTS: {
      let sortUploads = state.uploads;
      const mappedSaved = action.payload?.map(file => {
        if (file?.fileType in sortUploads) {
          const isDuplicate = sortUploads[file.fileType].files.find(
            uploadedFile => uploadedFile.fileName === file.fileName
          );
          if (!isDuplicate) {
            sortUploads[file.fileType].files.push(file);
          }
        }
        return { ...file, name: file.fileName };
      });
      return { ...state, saved: mappedSaved, uploads: sortUploads };
    }

    case ADD_ATTACHMENTS:
      return { ...state, saved: [...action.payload] };
    case REMOVE_ATTACHMENTS: {
      let sortKey;
      const saved = [...state.saved].filter(file => {
        const match = file.name !== action.payload;
        if (!match) sortKey = file.fileType;
        return match;
      });
      const sortRemoveUploads = {
        ...state.uploads,
        [sortKey]: {
          ...state.uploads[sortKey],
          files: state.uploads[sortKey].files.filter(file => file.fileName !== action.payload)
        }
      };
      return {
        ...state,
        saved,
        uploads: sortRemoveUploads
      };
    }
    case ADD_STAGING_ATTACHMENTS:
      return { ...state, staged: [...action.payload] };
    case REMOVE_STAGING_ATTACHMENTS: {
      const staged = [...state.staged].filter(file => file.name !== action.payload);
      return { ...state, staged };
    }
    case CLEAR_STAGING_ATTACHMENTS:
      return { ...state, staged: [] };
    case CLEAR_ALL_ATTACHMENTS:
      return {
        ...state,
        uploads: {
          addressAttachment: { required: false, files: [] },
          taxAttachment: { required: false, files: [] },
          ineAttachment: { required: false, files: [] },
          constitutiveActAttachment: { required: false, files: [] },
          financialStatementsAttachment: { required: false, files: [] },
          accountAttachment: { required: false, files: [] },
          taxExemptAttachment: { required: false, files: [] },
          financialCardAttachment: { required: false, files: [] },
          additionalAttachment: { required: false, files: [] }
        }
      };
    case UPDATE_ATTACHMENTS_VALIDATION:
      return {
        ...state,
        uploads: {
          ...state.uploads,
          [action.payload.key]: {
            ...state.uploads[action.payload.key],
            required: action.payload.required
          }
        }
      };
    default:
      return state;
  }
}

// Action Creators
export function getAttachments(payload) {
  return { type: GET_ATTACHMENTS, payload };
}

export function addAttachments(payload) {
  return { type: ADD_ATTACHMENTS, payload };
}
export function clearAllAttachments(payload) {
  return { type: CLEAR_ALL_ATTACHMENTS, payload };
}

export function removeAttachments(payload) {
  return { type: REMOVE_ATTACHMENTS, payload };
}

export function addStagingAttachments(payload) {
  return { type: ADD_STAGING_ATTACHMENTS, payload };
}

export function removeStagingAttachments(payload) {
  return { type: REMOVE_STAGING_ATTACHMENTS, payload };
}

export function clearStagingAttachments() {
  return { type: CLEAR_STAGING_ATTACHMENTS };
}

export function updateAttachmentsValidation(payload) {
  return { type: UPDATE_ATTACHMENTS_VALIDATION, payload };
}
